module.exports = __webpack_public_path__ + "img/logo.67e8d235.png";